<template>
  <div class="admin-dashboard">
    <h2 class="page-title">管理概览</h2>

    <div class="stats-row" v-loading="loading">
      <div class="stat-card">
        <div class="stat-icon" style="background:#409EFF">
          <i class="el-icon-document"></i>
        </div>
        <div class="stat-content">
          <span class="stat-value">{{ stats.article_count || 0 }}</span>
          <span class="stat-desc">总文章数</span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon" style="background:#67C23A">
          <i class="el-icon-check"></i>
        </div>
        <div class="stat-content">
          <span class="stat-value">{{ stats.published_count || 0 }}</span>
          <span class="stat-desc">已发布</span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon" style="background:#E6A23C">
          <i class="el-icon-edit"></i>
        </div>
        <div class="stat-content">
          <span class="stat-value">{{ stats.draft_count || 0 }}</span>
          <span class="stat-desc">草稿</span>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon" style="background:#F56C6C">
          <i class="el-icon-collection-tag"></i>
        </div>
        <div class="stat-content">
          <span class="stat-value">{{ stats.tag_count || 0 }}</span>
          <span class="stat-desc">标签</span>
        </div>
      </div>
    </div>

    <div class="recent-section" v-if="recentArticles.length">
      <h3 class="section-title">最近更新</h3>
      <el-table :data="recentArticles" stripe size="small">
        <el-table-column prop="title" label="标题" min-width="200" />
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'published' ? 'success' : 'warning'" size="mini">
              {{ scope.row.status === 'published' ? '已发布' : '草稿' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="120">
          <template slot-scope="scope">
            {{ formatDate(scope.row.updated_at) }}
          </template>
        </el-table-column>
        <el-table-column label="浏览" width="70" prop="view_count" />
      </el-table>
    </div>
  </div>
</template>

<script>
import { adminApi } from '../../utils/api'

export default {
  name: 'AdminDashboard',
  data() {
    return {
      stats: {},
      recentArticles: [],
      loading: false
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await adminApi.getDashboard()
        this.stats = res.stats
        this.recentArticles = res.recent_articles || []
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      return `${d.getMonth()+1}/${d.getDate()}`
    }
  }
}
</script>

<style scoped>
.page-title {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
}
.stats-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}
.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  border: 1px solid #e8e8e8;
}
.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  margin-right: 16px;
}
.stat-content {
  display: flex;
  flex-direction: column;
}
.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #2c3e50;
}
.stat-desc {
  font-size: 13px;
  color: #999;
}
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 12px;
}
.recent-section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e8e8e8;
}
@media (max-width: 768px) {
  .stats-row {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
